import { Component, OnChanges, Input, SimpleChange, EventEmitter, Output } from '@angular/core';
@Component({
  selector: 'app-password-strength-bar',
  templateUrl: './password-strength-bar.component.html',
  styleUrls: ['./password-strength-bar.component.scss'],
})
export class PasswordStrengthBarComponent implements OnChanges {
  @Input() passwordToCheck: string;
  @Input() barLabel: string;
  @Output() strength = new EventEmitter<any>();
  backgroundColor: string;
  scorePercent: number = 0;

  private colors = ['#DC3E45', '#FFC235', '#FF0', '#9F0', '#43A745'];

  private static measureStrength(pass: string) {
    let score = 0;
    // award every unique letter until 5 repetitions
    const letters = {};
    for (let i = 0; i < pass.length; i++) {
      letters[pass[i]] = (letters[pass[i]] || 0) + 1;
      score += 5.0 / letters[pass[i]];
    }
    // bonus points for mixing it up
    const variations = {
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass),
    };

    let variationCount = 0;
    for (const check in variations) {
      if (variations[check]) {
        variationCount++;
      }
    }
    score += (variationCount - 1) * 10;
    return Math.trunc(score);
  }

  private getColor(score: number) {
    this.scorePercent = score;

    let idx = 0;
    if (score > 90) {
      idx = 4;
      this.strength.emit({ color: this.colors[4], message: 'VERY GOOD' });
    } else if (score > 70) {
      idx = 3;
      this.strength.emit({ color: this.colors[3], message: 'GOOD' });
    } else if (score >= 40) {
      idx = 2;
      this.strength.emit({ color: this.colors[2], message: 'AVERAGE' });
    } else if (score >= 20) {
      idx = 1;
      this.strength.emit({ color: this.colors[1], message: 'POOR' });
    } else {
      this.strength.emit({ color: this.colors[0], message: 'VERY POOR' });
    }
    return {
      idx: idx + 1,
      col: this.colors[idx],
    };
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes['passwordToCheck'].currentValue;
    this.setBarColors(5, '#DDD');
    if (password) {
      const c = this.getColor(PasswordStrengthBarComponent.measureStrength(password));
      this.setBarColors(c.idx, c.col);
    }
  }
  private setBarColors(count, col) {
    this.backgroundColor = col;
  }
}
